module.exports = __webpack_public_path__ + "96f1765b4f2fcddbea0074c1ad4ef849.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/wrench.png
// module id = 2447
// module chunks = 0